/**
 * Created by Jerker Nord on 2023-10-06.
 */
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {SimplePresentation, SimplePresentationRunner} from "../../../core/winpresentation/SimplePresentationRunner";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {
    LonerTickTickBoomStartPresentation
} from "../../presentationrunners/features/ticktickboom/LonerTickTickBoomStartPresentation";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {
    LonerTickTickBoomIntroPresentation
} from "../../presentationrunners/features/ticktickboom/LonerTickTickBoomIntroPresentation";

export class LonerTickTickBoomIdleTrigger implements FlowStatePresentation {

    private _presentations: SimplePresentation[];
    private _flowStateController: FlowStateController;

    constructor() {
        this._presentations = [
            new LonerTickTickBoomIntroPresentation(),
            new LonerTickTickBoomStartPresentation()
        ]
    }

    start(flowStateController: FlowStateController): void {
        this._flowStateController = flowStateController;
        SimplePresentationRunner.run(this._presentations, () => this.complete(), (callback?: Function) => flowStateController.setSkipCallback(callback));
    }

    public complete(): void {
        this._flowStateController.finish();
    }
}